import { Sprite } from './Sprite';
import { Texture } from './Texture';

export class NineSlicePlane extends Sprite {
  constructor(
    texture: Texture,
    left: number,
    top: number,
    right: number,
    bottom: number,
  ) {
    super(texture);
    // console.warn(
    //   'Not yet implemented: NineSlicePlane',
    //   texture,
    //   left,
    //   top,
    //   right,
    //   bottom,
    // );
  }
}
